var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechnologyAdded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.249,
    y: 11.208,
    width: 1.417,
    height: 5.667,
    rx: 0.708
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.124,
    y: 13.334,
    width: 5.667,
    height: 1.417,
    rx: 0.708
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.166 2a.708.708 0 00-.708.708v.709h-.625a1.5 1.5 0 00-1.5 1.5v11.167a1.5 1.5 0 001.5 1.5h4.166v-1.417H5.5a.75.75 0 01-.75-.75V8.375h11.333v1.417H17.5V4.917a1.5 1.5 0 00-1.5-1.5h-.626v-.709a.708.708 0 10-1.416 0v.709H6.875v-.709A.708.708 0 006.166 2zM4.75 6.959h11.333V5.583a.75.75 0 00-.75-.75H5.5a.75.75 0 00-.75.75V6.96z"
  })));
}
export default SvgTechnologyAdded;